import Axios from 'api/client';
import { BulkActionResource, BulkActionStatus, BulkActionType } from 'constants/bulkActions';
import { BulkAction } from 'types/domain';
import { PaginatedData } from 'types/pagination';
import { FilterParams } from 'types/params';
import { OutboundFilters } from 'types/request';

interface FetchBulkActionsParams extends FilterParams {
    resource?: BulkActionResource;
    status?: BulkActionStatus[];
}

type BulkActionFilters = OutboundFilters & {
    query?: string;
    type?: string;
    archiveOnly?: boolean;
};

interface BulkActionDataIds {
    ids?: number[];
}

interface CreateBulkActionParamsBase<T extends BulkActionType, K = {}> {
    type: T;
    filters?: BulkActionFilters;
    data: BulkActionDataIds & K;
}

type GenericBulkActionParams = CreateBulkActionParamsBase<
    | BulkActionType.ARCHIVE_CONTACTS
    | BulkActionType.UNARCHIVE_CONTACTS
    | BulkActionType.DELETE_CONTACTS
>;

type UpdateTagsBulkActionParams = CreateBulkActionParamsBase<
    BulkActionType.ADD_CONTACT_TAGS | BulkActionType.REMOVE_CONTACT_TAGS,
    {
        tags: string[];
    }
>;

type ManageEngageSubscriptionsBulkActionParams = CreateBulkActionParamsBase<
    BulkActionType.MANAGE_CONTACT_ENGAGE_SUBSCRIPTIONS,
    {
        is_email_subscribed: boolean | null;
        is_phone_subscribed: boolean | null;
        is_address_subscribed: boolean | null;
    }
>;

type CreateBulkActionParams =
    | GenericBulkActionParams
    | UpdateTagsBulkActionParams
    | ManageEngageSubscriptionsBulkActionParams;

const getBulkActions = (accountId: number, params: FetchBulkActionsParams) => {
    const { filters, ...rest } = params;
    return Axios.post<PaginatedData<BulkAction>>(`/accounts/${accountId}/get_bulk_actions`, {
        ...filters,
        ...rest,
    }).then(response => response.data);
};

const getBulkAction = (accountId: number, bulkActionId: number) => {
    return Axios.get<BulkAction>(`/accounts/${accountId}/bulk-actions/${bulkActionId}`).then(
        response => response.data,
    );
};

const createBulkAction = (accountId: number, params: CreateBulkActionParams) =>
    Axios.post<BulkAction>(`/accounts/${accountId}/bulk-actions`, params).then(
        response => response.data,
    );

export { getBulkActions, getBulkAction, createBulkAction };
export type { FetchBulkActionsParams, CreateBulkActionParams };
